import { PeeqdToolContent } from "@/config/peeqdContent";

interface PeeqdToolTitleProps {
  content: PeeqdToolContent;
  align?: "center" | "start";
}

export default function PeeqdToolTitle({
  content,
  align = "center",
}: PeeqdToolTitleProps) {
  const centered = align === "center";

  return (
    <div className={centered ? "text-center" : "text-left"}>
      <span className="inline-flex items-center gap-2 rounded-full bg-rose-soft px-3 py-1 text-[12.5px] font-semibold text-rose-deep">
        <span className="h-1.5 w-1.5 rounded-full bg-rose ring-pulse" />
        {content.eyebrow}
      </span>
      <h1
        className={`mt-4 font-display font-extrabold leading-[1.04] tracking-tight text-ink ${
          centered
            ? "text-[34px] sm:text-[46px]"
            : "text-[26px] sm:text-[34px] lg:text-[38px]"
        }`}
        dangerouslySetInnerHTML={{ __html: content.titleHtml }}
      />
      <p
        className={`mt-3 text-[15px] leading-relaxed text-muted sm:text-[16px] ${
          centered ? "mx-auto max-w-xl" : "max-w-2xl"
        }`}
      >
        {content.description}
      </p>
    </div>
  );
}
